import React from 'react';

import rapidFireProduct from '../../../main/assets/images/rapidFire/rapid-fire-product.webp';

export const Landing = () => {
  return (
    <div className="rapid-fire-landing-section">
      <div className="rapid-fire-landing-text">
        <div className="rapid-fire-landing-titles">
          <h1 className="rapid-fire-landing-subtitle">
            rapidFIRE VIDEO RECEIVER
          </h1>
          {/* <h2 className="rapid-fire-landing-title">
            Next-Gen signal reception
          </h2> */}
          <h2 className="rapid-fire-landing-title">
            GOLD STANDARD VRX RECEPTION
          </h2>
        </div>
        <p className="rapid-fire-landing-description">
          The rapidFIRE 5.8Ghz Video Receiver redefines the FPV experience
          thanks to its advanced signal processing and powerful features.
          Engineered to provide crystal-clear, interference-free video, it's the
          ultimate receiver for serious FPV pilots who demand ultra-reliable
          performance in every environment.
        </p>
        <div className="dreamX__discover--button">
          <a
            href="https://shop.orqafpv.com/products/rapidfire-5-8ghz-video-receiver?_pos=1&_sid=17705dc81&_ss=r"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn--primary btn--med"
            onMouseDown={event => event.preventDefault()}
          >
            buy now
          </a>
        </div>
      </div>
      <div className="rapid-fire-landing-image-container">
        <div
          className="rapid-fire-landing-effect"
          style={{ filter: 'blur(2px)' }}
        />
        <img
          src={rapidFireProduct}
          alt="5.8 GHz Signal Video Receiver Product"
          className="rapid-fire-landing-product"
        />
      </div>
    </div>
  );
};
